"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _framerMotion = require("framer-motion");
var _MemberToast = _interopRequireDefault(require("./MemberToast"));
var MemberToastManager = function MemberToastManager(_ref) {
  var toasts = _ref.toasts,
    removeItem = _ref.removeItem,
    buttonTheme = _ref.buttonTheme;
  var sortedToasts = toasts.slice().sort(function (a, b) {
    if (a.isPrioritized && !b.isPrioritized) {
      return -1;
    } else if (!a.isPrioritized && b.isPrioritized) {
      return 1;
    } else {
      return 0;
    }
  });
  return /*#__PURE__*/_react["default"].createElement(_framerMotion.AnimatePresence, null, sortedToasts.map(function (toast, idx) {
    return /*#__PURE__*/_react["default"].createElement(_MemberToast["default"], (0, _extends2["default"])({
      key: toast.id
    }, toast, {
      isFirstInQueue: idx === 0,
      removeItem: removeItem,
      buttonTheme: buttonTheme
    }));
  }));
};
var _default = exports["default"] = MemberToastManager;
//# sourceMappingURL=MemberToastManager.js.map